import { Controller } from "@hotwired/stimulus";
import PresenceCalendar from "@components/presence-calendar/presence-calendar.svelte";
import { mount, unmount } from "svelte";
import { isPreviewMode } from "@lib/utils";

const COMPONENT_KEY = "__svelteComponent"

// Connects to data-controller="presence-calendar-svelte"
export default class extends Controller {

  connect() {
    if (isPreviewMode()) return
    
    const users = JSON.parse(this.element.dataset.users);
    const user = JSON.parse(this.element.dataset.user);
    const clinic = JSON.parse(this.element.dataset.clinic);
    const month = new Date(this.element.dataset.month);
    const role = this.element.dataset.role;
    const userType = this.element.dataset.userType;
    const dates = JSON.parse(this.element.dataset.dates).map(
      (date) => new Date(date),
    );
    const mode = this.element.dataset.mode;

    this.teardown()
    if (this.beforeCache) document.removeEventListener("turbo:before-cache", this.beforeCache)
    this.beforeCache = () => this.teardown()
    document.addEventListener("turbo:before-cache", this.beforeCache)

    const component = mount(PresenceCalendar, {
      target: this.element,
      props: { clinic, user, users, month, dates, mode, role, userType },
    });
    this.component = component
    this.element[COMPONENT_KEY] = component
  }

  disconnect() {
    if (this.beforeCache) {
      document.removeEventListener("turbo:before-cache", this.beforeCache)
      this.beforeCache = null
    }
    this.teardown()
  }

  teardown() {
    const existing = this.element[COMPONENT_KEY] || this.component
    if (existing) unmount(existing)
    this.element[COMPONENT_KEY] = null
    this.component = null
    this.element.innerHTML = ""
  }

}
